import { notification } from '@pu/mpp-ui/notifications';
import type { ISegmentedBannerListItem } from 'core/model/interfaces/banners';
import type { IFiltersPlatform } from 'core/model/interfaces/filters';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IBannersState } from '../types';

export const publishBannerList = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/publishBannerList`,
  async (params: ISegmentedBannerListItem & IFiltersPlatform, { rejectWithValue }) => {
    try {
      const { platform, ...segmentedBanners } = params;

      await apiService.banners.publishSegmentedBannerList(segmentedBanners);

      notification.success('Banners publicados correctamente.');

      return params;
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al publicar los banners.');

      notification.error(errorMessage);

      return rejectWithValue(error);
    }
  },
);

export const publishBannerListReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(publishBannerList.pending, state => {
      state.publish.loading = true;
      state.publish.success = false;
      state.publish.error = null;
    })
    .addCase(publishBannerList.rejected, (state, action) => {
      state.publish.loading = false;
      state.publish.success = false;
      state.publish.error = action.error.message || 'Error al publicar los banners';
    })
    .addCase(publishBannerList.fulfilled, (state, action) => {
      const { platform, index, banners } = action.payload;

      state.publish.loading = false;
      state.publish.success = true;
      state.publish.error = null;

      /**
       * Find the segmented banner by custom identifier (index) and update its banners
       * to avoid unnecessary API calls (refetching the entire list).
       *
       * **Optimistic update**: It works like a charm
       */
      const foundSegmentedBanner = state.visualizationTab[platform].banners.find(banner => banner.index === index);

      if (foundSegmentedBanner) {
        foundSegmentedBanner.banners = banners;
      }
    });
